import React from 'react'

export const CircularFilledSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.375 7.63086C0.375 11.4969 3.50901 14.6309 7.375 14.6309C11.241 14.6309 14.375 11.4969 14.375 7.63086C14.375 3.76487 11.241 0.630859 7.375 0.630859C3.50901 0.630859 0.375 3.76487 0.375 7.63086ZM10.7004 6.93253C10.8968 6.73394 10.895 6.41373 10.6964 6.21732C10.4979 6.02091 10.1777 6.02268 9.98124 6.22127L7.37501 8.8564L4.76877 6.22127C4.57236 6.02268 4.25215 6.02091 4.05356 6.21732C3.85497 6.41373 3.85321 6.73394 4.04962 6.93253L6.65586 9.56767C7.05174 9.96794 7.69827 9.96794 8.09415 9.56767L10.7004 6.93253Z"
        fill="#3E4685"
      />
    </svg>
  )
}
